import type { RetailCartLineInput } from '../interfaces';

const EPSILON = 0.001;

function _parseAmount(value: string | number | null | undefined): number {
  const num = parseFloat(String(value ?? 0));

  return Number.isNaN(num) ? 0 : num;
}

/** NOTE :: True when the reference/original line total is above the charged amount (markdown / discount), not markup. */
function shouldShowMarkdownRetailComparison(originalTotal: number, lineAmount: number): boolean {
  return originalTotal > lineAmount + EPSILON;
}

/**
 * Line totals for retail rows in cart summary (sidebar + summary step).
 * showComparison only for markdown (charged line below original total); markups show updated value only.
 */
function getRetailLinePriceEditDisplayHelper(item: RetailCartLineInput): {
  lineAmount: number;
  originalLineTotal: number;
  showComparison: boolean;
} | null {
  const quantity = typeof item.quantity === 'number' ? item.quantity : 1;
  if (quantity <= 0) return null;

  const currentPrice = _parseAmount(item.price);
  const originalUnitPrice = item.original_price != null ? _parseAmount(item.original_price) : currentPrice;
  const isPriceEdited = !!item.is_price_edited;
  const hasPromo = _parseAmount(item.discount_amount) > 0 || !!item.discount_code;

  const lineAmount = hasPromo ? currentPrice * quantity : _parseAmount(item.subtotal) || currentPrice * quantity;
  if (lineAmount < 0) return null;

  const originalLineTotal = originalUnitPrice * quantity;
  const showComparison = isPriceEdited && shouldShowMarkdownRetailComparison(originalLineTotal, lineAmount);

  return { lineAmount, originalLineTotal, showComparison };
}

export { getRetailLinePriceEditDisplayHelper, shouldShowMarkdownRetailComparison };
